const r = "Appuyez sur la touche Tab pour accéder au popover", t = {
  triggerHint: r
};
export {
  t as default,
  r as triggerHint
};
